import { loadManifest } from '@angular-architects/module-federation';

loadManifest('/assets/manifest.json')
  .catch((err: TypeError) => {
    console.error(err);
    if (err.message.includes('https://adviserportal') || err.message.includes('http://localhost:4202')) {
      sessionStorage.setItem('new-business-remote-active', 'false');
    }
    if (err.message.includes('https://qfa') || err.message.includes('http://localhost:4201')) {
      sessionStorage.setItem('qfa-remote-active', 'false');
    }
  })
  .then(_ => import('./bootstrap'))
  .catch(err => {
    console.error(err);
  });
